import { render } from "./Pagination.vue?vue&type=template&id=69cb5c6e&ts=true"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69cb5c6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69cb5c6e', __exports__)) {
    api.reload('69cb5c6e', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=69cb5c6e&ts=true", () => {
    api.rerender('69cb5c6e', render)
  })

}


export default __exports__